import { updateSharedState } from '@/utils/storage/sharedState';

// Read by the onboarding miniapp; an absent key means the quota is untouched.
export const markFreeQuotaSpent = () =>
  updateSharedState({ freeQuotaSpent: true });
